module.exports = __webpack_public_path__ + "media/images/partners/swiss-contact-7e80c7041ea012abc210f48500264baf.png";